<template>
  <form
    role="search"
    action=""
    @submit.prevent="onFormSubmit"
    :class="bem('form')"  >
    <slot>
      <v-layout row >
        <v-flex xs9 lg10>
          <ais-input
            @keyup.enter="searchStoreRefresh()"
            :search-store="searchStore"
            :placeholder="placeholder"
            :autofocus="autofocus"
            :class-names="classNames"
          >
          </ais-input>
          <div v-if="showLoadingIndicator" :hidden="!searchStore.isSearchStalled" :class="bem('loading-indicator')" >
            <slot name="loading-indicator" >
              <svg width="1em" height="1em" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#000">
                <g fill="none" fill-rule="evenodd">
                  <g transform="translate(1 1)" stroke-width="2">
                    <circle stroke-opacity=".5" cx="18" cy="18" r="18"/>
                    <path d="M36 18c0-9.94-8.06-18-18-18">
                      <animateTransform
                      attributeName="transform"
                      type="rotate"
                      from="0 18 18"
                      to="360 18 18"
                      dur="1s"
                      repeatCount="indefinite"/>
                    </path>
                  </g>
                </g>
              </svg>
            </slot>
          </div>
        </v-flex>
        <v-flex xs3 lg3>
          <div style="width: 135px">
            <v-btn type="submit" small  @click.prevent="searchStoreRefresh()" position="center center"
            class="white--text v-btn theme--light" style="margin-top:18px; min-width: 55px;background-color: #f6a200;float:left"
            >Search</v-btn>
            <ais-clear />
          </div>
        </v-flex>
      </v-layout>
    </slot>
  </form>
</template>

<script>
import { SearchBox } from 'vue-instantsearch'
import { mapMutations } from 'vuex'
import AisInput from './AisInput.vue'
import AisClear from './AisClear.vue'

export default {
  name: 'ais-search-box',
  extends: SearchBox,
  data () {
    return {
      blockClassName: 'ais-search-box'
    }
  },
  components: {
    AisInput,
    AisClear
  },
  methods: {
    ...mapMutations(['setGlobalSearch']),
    searchStoreRefresh () {
      this.searchStore.refresh()
      this.setGlobalSearch(this.searchStore.query)
    }
  },
  mounted () {
    if (this.$route.params.search) {
      this.searchStore.query = this.$route.params.search
    }
  }
}
</script>
<style>
</style>
